import { ReactNode } from 'react';
import cn from 'classnames';
import styles from '../TextButton/TextButton.module.scss';

type Size = 'small' | 'medium' | 'large';

export interface TextButtonLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  size?: Size;
  className?: string;
}

const TextButtonLink = ({
  href,
  children,
  size = 'small',
  className,
  target,
  rel,
  ...anchorProps
}: TextButtonLinkProps) => {
  if (!href || href.trim() === '') {
    console.warn('TextButtonLink: href prop is required and cannot be empty');
    return null;
  }

  const isExternal = target === '_blank';
  const relValue = isExternal
    ? rel
      ? `${rel} noopener noreferrer`
      : 'noopener noreferrer'
    : rel;

  return (
    <a
      href={href}
      className={cn(
        styles.textButton,
        styles.tertiary,
        styles[size],
        className
      )}
      target={target}
      rel={relValue}
      {...anchorProps}
    >
      {children}
    </a>
  );
};

TextButtonLink.displayName = 'TextButtonLink';

export default TextButtonLink;
